export { default as GenericError } from './GenericError';
export type { IGenericErrorProps } from './GenericError';
